import Vue from 'vue'
import Router from 'vue-router'
import ElementUI from 'element-ui'
Vue.use(ElementUI);

import UserRegister from '../components/kjfx/login/UserRegister.vue'
import UserLogin from '../components/kjfx/login/UserLogin.vue'
import KjfxPage from '../components/kjfx/main/KjfxPage.vue'
import YwQueryPage from '../components/ywxt/YwQueryPage'
import ZydjMain from '../components/zydj/main.vue'
import ZydjWsbl from '../components/zydj/wsbl.vue'
import JfjjzMain from '../components/zydj/mainJf.vue'
import ZydjLegalMain from '../components/zydj/LegalMain.vue'
import Cookie from "cookies-js";
Vue.use(Router)

export const constantRouterMap = [
  {
    path:'/login',
    name:'UserLogin',
    component:UserLogin
  },
  {
    path:'/',
    redirect:'/login'
  },
 /* {
    path:"/userRegister",
    name:'UserRegister',
    component:UserRegister
  },*/
  {
    path:"/KjfxPage",
    name:'KjfxPage',
    component:KjfxPage,
    meta:{
      titleName:'建设项目选址空间分析'
    }
  },
  {
    path:"/ZydjLegalMain",
    name:'ZydjLegalMain',
    component:ZydjLegalMain,
    meta:{
      titleName:'榆林市涉企不动产登记'
    }
  },
  {
    path:"/ZydjMain",
    name:'ZydjMain',
    component:ZydjMain,
    meta:{
      titleName:'榆林市二手房转移登记及水电气暖联动过户'
    }
  },{
    path:"/ZydjWsbl",
    name:'ZydjWsbl',
    component:ZydjWsbl,
    meta:{
      titleName:'榆林市不动产登记网上办理'
    }
  },
  {
    path:"/JfjjzMain",
    name:'JfjjzMain',
    component:JfjjzMain,
    meta:{
      titleName:'榆林市新建商品房交房即交证一件事一次办'
    }
  },
  {
    path:"/YwQueryPage",
    name:'YwQueryPage',
    component:YwQueryPage,
    meta:{
      titleName:'业务查询'
    }
  },

]
const router =  new Router({
  mode:'hash',
  // base:'/kjfx/',
  routes:constantRouterMap
})
router.beforeEach((to,from,next)=>{
  var self =this;
  var userIsLogin =Cookie.get("wwJcptToken");
  var userRoles = Cookie.get("jglx");
  if(to.meta.isLogin){
    if(userIsLogin){
      if(to.meta.roles.indexOf(String(userRoles)) >= 0){
        next()
      }else {
        alert('无效或非法请求！')
        router.push('/login')
      }
    }else {
      alert('请登录之后再操作！')
      router.push('/login')
    }
  }else {
    next()
  }
})

router.afterEach((to,from)=>{
  if (to.meta.titleName) {
    document.title=to.meta.titleName
  }
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js